import { useCallback } from 'react';

import { type AirActionTrackingLocation, useTrackDownloadedItems } from '@air/analytics';

import { useCreatePublicZippingTask } from '~/components/ZippingTasks/hooks/useCreatePublicZippingTask';

type DownloadPublicShowcaseParams = {
  /** Id of the collection whose contents should be downloaded */
  collectionId: string;
  /** Where in the UI this was called from */
  trackLocation: AirActionTrackingLocation;
};

/**
 * Creates a public zipping task scoped to a single collection (no boards/clips) and tracks the download.
 */
export function useDownloadPublicShowcase() {
  const { trackDownloadedItems } = useTrackDownloadedItems();
  const { createPublicZippingTask } = useCreatePublicZippingTask();

  const downloadPublicShowcase = useCallback(
    ({ collectionId, trackLocation }: DownloadPublicShowcaseParams) => {
      createPublicZippingTask({
        boardIds: undefined,
        clipIds: undefined,
        collectionIds: [collectionId],
      });

      trackDownloadedItems({
        collectionIds: [collectionId],
        location: trackLocation,
      });
    },
    [createPublicZippingTask, trackDownloadedItems],
  );

  return { downloadPublicShowcase };
}
